$('.accessories__nav a').on('click',function(e){
  e.preventDefault()
    const id = $(this).data('id')
    $('.story-product-blocks .accessories__list').hide()
    $('.accessories__nav a').removeClass('active')
    $(this).addClass('active')
    $(id).show();

  const swiper = document.querySelector('.carousel-2').swiper;
  swiper.update();

})
function changeButtonText() {
  let langCode = Weglot.getCurrentLang();
  // document.querySelectorAll('.personalisation-popup-open').forEach(button => button.innerText = window.translations.personalisation.add_engraving[langCode])
  document.querySelectorAll('.mini-cart .personalisation-popup-open').forEach(button => button.innerText = window.translations.personalisation.edit_engraving[langCode])
}
$('.accs-product__image .swiper-wrapper').children().eq(1).on('click',function(e){
    $(this).parents(".accs-product__card").find('.acc-product__info').trigger('click')
});

$('.acc-product__info,.card_image_2').on('click',function(e){
    $(this).parents(".accs-product__card").addClass("acc-product__active")
})


$('.acc-description__head').on('click',function(e){
    $(this).parents(".accs-product__card").removeClass("acc-product__active")
})

$(function() {
  $('.popup-submit').on('click',function(e){   
    e.preventDefault();
    $(this).submit();
    console.log('submit', $(this))
  });
});

$(function() {
$('.accessories-add-forms').submit(function(e){
  e.preventDefault()
  var varid = $(this).find('.variant-id').val();

  window.currentProduct = JSON.parse(this.closest('[data-product]').dataset.product);
  window.currentProduct.selectedVariant = window.currentProduct.variants.find((variant)=>{ return variant.id == varid });

  CartJS.addItem(varid,1)
  //   CartJS.getCart();

  var event = new Event("addedToCartDatalayer");
  // Dispatch the event.
  window.dispatchEvent(event);

  $('span.js-el__mini-cart-click-trigger').click();
  //$('.accs-close span').hide()
  let popupSubmit = $(this).find('.popup-submit');
  let popupAdded = $(this).find('.popup-added');
  
  popupSubmit.addClass("utl--hide");
  popupAdded.removeClass("utl--hide");
  setTimeout(() => {
    popupSubmit.removeClass("utl--hide");
    popupAdded.addClass("utl--hide");
  }, 1000)
  
$('.accs-product__image .swiper-slide').eq(1).on('click',function(e){
    $(this).parents(".accs-product__card").addClass("acc-product__active")
});
  
//   return;
}) 
});
$('.active-desk-popup-open').each(function (index) {
    $(this).on('click',function(e){
      $('.aeris-active-office-desk-popup').css("display","none");	
      $('.aeris-active-desk-popup').css("display","block");	
    })
})
$('.active-office-desk-popup-open').each(function (index) {
    $(this).on('click',function(e){
      $('.aeris-active-desk-popup').css("display","none");	
      $('.aeris-active-office-desk-popup').css("display","block");	
    })
})

function synchronizeLinkedProductQuantitys(cart = CartJS.cart) {
  let AllLinkedItems = getAllLinkedItems(cart);

  let mainItemsWithLinkedItems = getMainItemsWithLinkedItems(cart);
  let updatesObj = {
    updates:{}
  };

  //sync linked items quantity with main item

  let mainItemsWithLinkedWithDifferentQuantity = mainItemsWithLinkedItems.reduce((prev, item)=>{
      let linkedItems = item.linkedItems.filter((cartItem)=>{
          if (cartItem != item.mainItem && cartItem.quantity != item.mainItem.quantity) {
              return cartItem
          }
      })
      if (linkedItems.length > 0) {
          prev.push({mainItem:item.mainItem, linkedItems});
      }
      return prev
  }, []);
  mainItemsWithLinkedWithDifferentQuantity.forEach((item)=>{
      item.linkedItems.forEach((linkedItem)=>{
        updatesObj.updates[`${linkedItem.key}`] = item.mainItem.quantity;
          // CartJS.updateItem(linkedItem.line_number + 1, item.mainItem.quantity);
      })
  })

  

  //remove linked items that have no main item

  let linkedItemsWithMainItems = mainItemsWithLinkedItems.reduce((prev,cur)=>{
      prev.push(cur.mainItem);
      return prev.concat(cur.linkedItems)
  }, []);

  let mainItems = getMainItems(cart);

  let linkedItemsToRemove = AllLinkedItems.filter((item)=>{
      return linkedItemsWithMainItems.indexOf(item) == -1 && mainItems.indexOf(item) == -1;
  });

  linkedItemsToRemove.forEach((linkedItem)=>{
    updatesObj.updates[`${linkedItem.key}`] = 0;
      // CartJS.updateItem(linkedItem.line_number + 1, 0);
  });

  if (updatesObj.updates && Object.keys(updatesObj.updates).length > 0) {
    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: updatesObj,
      success: (res)=>{
        CartJS.getCart();
        cartPageRefresh()
      },
      dataType: 'json'
    });
  }
}

async function personalisationCleanUp(cart) {
  cart = cart || await CartJS.getCart();
  let mainItems = getMainItems(cart);
  if(!mainItems){ setTimeout(personalisationCleanUp, 50, cart); return; }
  let mainItemsWithlinkedID = mainItems.map((item,index)=>{
    item.line_number = index;
    return item
  }).filter((item)=>{return item.properties?.linkedID != null});

  let MainItemsWithLinkedItems = getMainItemsWithLinkedItems(cart).reduce((prev,cur)=>{
    return prev.concat(cur.mainItem);
  }, []);

  let personalisedItemsWithoutLinkedItem =  mainItemsWithlinkedID.filter((item)=>{
    return MainItemsWithLinkedItems.indexOf(item) == -1;
  });
  personalisedItemsWithoutLinkedItem.forEach((item)=>{
    let props = item.properties || {};
    if (Object.keys(props).length <= 0) {return}
    if (props.Engraved != null) {
      delete props.Engraved;
      delete props.linkedID;
    }

    let updatesObj = {
      updates:{}
    };
    updatesObj.updates[`${item.key}`] = 0;

    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: updatesObj,
      success: (res)=>{
        CartJS.addItem(item.id, item.quantity, props);
        cartPageRefresh()
      },
      dataType: 'json'
    });
  })
}

function getMainItems(cart) {
  return cart?.items.filter((item)=>{
    if (item.properties) {
      let propertyKeys = Object.keys(item.properties).map((key)=>{return key.toLowerCase()});
      return propertyKeys.indexOf('engraveitem') == -1 && propertyKeys.indexOf('linkedid') !== -1;
    }
    return true;
  });
}

function getAllLinkedItems(cart) {
  return cart.items.filter((cartItem, index)=>{
    if (cartItem.properties?.linkedID != null) {
      cartItem.line_number = index;
      return cartItem
    }
  })
}

function getMainItemsWithLinkedItems(cart) {
  let mainItems = getMainItems(cart);
  let AllLinkedItems = getAllLinkedItems(cart);

  return mainItems.reduce((prev, mainItem)=>{
    let linkedItems = AllLinkedItems.filter((cartItem)=>{
      if (cartItem.properties?.linkedID == mainItem.properties.linkedID && cartItem != mainItem) {
        return cartItem
      }
    })
    if (linkedItems.length > 0) {
      prev.push({mainItem:mainItem, linkedItems});
    }
    return prev
  }, []);
}
function sortCart() {
  CartJS.cart.items = Object.assign({},CartJS.cart.items).sort((a,b)=>{
    if (a.properties.linkedID == b.properties.linkedID) {
      if (a.properties.EngraveItem != null || a.handle.indexOf('swopper') == -1){
        return 1;
      } else {
        return -1;
      }
    }
    return 0;
  });
  refreshMiniCart();
}

function cartPageRefresh() {
  if (window.location.pathname.indexOf('cart') !== -1) {
    window.setTimeout(()=>{
      fetch('/cart')
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        if (doc.querySelectorAll('.table_product_single').length == document.querySelectorAll('.table_product_single').length) {

          //if there are the same amount of rows, update required dated for less flash
          doc.querySelectorAll('.cart_area [data-item-key]').forEach((item,index) => { document.querySelectorAll('.cart_area [data-item-key]')[index].dataset.itemKey = item.dataset.itemKey })
          doc.querySelectorAll('.table_product_single .form_quantity_input').forEach((item,index) => { document.querySelectorAll('.table_product_single .form_quantity_input')[index].value = item.value })

          let selectorArr = ['.cart_order', '.table_product_single .table_total', '.table_product_single .table_info_group .table_product_info'];

          let docItemArr = doc.querySelectorAll(selectorArr.join(', '));
          let htmlItemArr = document.querySelectorAll(selectorArr.join(', '));
          let itemsToUpdate = [].slice.call(docItemArr).reduce((prev,cur, index)=>{
            if (cur.innerHTML == htmlItemArr[index].innerHTML) {
              return prev;
            }
            prev.push({doc:cur,html:htmlItemArr[index]})
            return prev;
          },[]);

          itemsToUpdate.forEach((item)=>{
            item.html.innerHTML = item.doc.innerHTML;
          })
        } else {
          // refresh all of the cart
          let cartArea = doc.querySelector('.cart_area');
          document.querySelector('.cart_area').replaceWith(cartArea);
        }
        window.requestAnimationFrame(()=>{
          refreshMiniCart();
          addCartQuantityUpdaters()
        })
      })
      .catch(function(err) {
        console.log('Failed to fetch page: ', err);
      });
    }, 200);
  }
}
var cart_requestComplete;
function cartCompleteHandler(){
  $(document).on('cart.requestStarted', function(event, cart) {
    window.oldCart = JSON.parse(JSON.stringify(cart));
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    let oldCart = window.oldCart || {items: [], item_count: 0};

    if (JSON.stringify(oldCart) != JSON.stringify(cart)) {

      let changedItems = cart.items.reduce((prev, item, index) => {
          if (oldCart.items.length == cart?.items.length) {
            if (item.quantity != oldCart.items[index]?.quantity) {
              item.changedQuantity = Math.abs(oldCart.items[index].quantity - item.quantity);
              prev.push(item);
            }
          }
          return prev
        },[]);

      if (changedItems.length == 0) {
        changedItems = oldCart.items.reduce((prev, item) => {
          if (!cart.items?.find((x)=>{ return item.id == x.id })) {
            item.changedQuantity = item.quantity;
            prev.push(item);
          }
          return prev;
        },[]);
      }

      if (oldCart?.item_count < cart.item_count) {
        miniCart.addToCart(changedItems);
      } else {
        miniCart.removeFromCart(changedItems);
      }
    }

    cart_requestComplete = requestAnimationFrame(()=>{
 
      cancelAnimationFrame(cart_requestComplete);

      if(window.cartViewedGASent === false && window.location.pathname === "/cart"){
        const { items } = cart;
        var gaItems = [];
        for(var i = 0; i < items.length; i++) {
          var item = items[i];
          var gaItem = {
            item_id: item.sku,
            item_name: item.title,
            affiliation: Shopify.shop,
            currency: Shopify.currency.active,
            discount: item.discounted_price * 0.01,
            index: i,
            item_brand: item.vendor,
            item_category: item.product_type,
            item_variant: item.variant_title,
            price: item.price * 0.01,
            quantity: item.quantity
          };
          gaItems.push(gaItem);
        }
  
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_cart",
          ecommerce: {
              currency: Shopify.currency.active,
              value: CartJS.cart.checkout_charge_amount,
              items: gaItems
          }
        });
      }

      window.cartViewedGASent = true;

      synchronizeLinkedProductQuantitys(cart);
      requestAnimationFrame(()=>{
        // sortCart();
        refreshMiniCart();
      });
      personalisationCleanUp(cart);
      cartPageRefresh();
    })
  });
}

window.addEventListener('DOMContentLoaded', ()=>{
  //cartCompleteHandler();
  window.cartViewedGASent = false;
});

window.addEventListener('load', () => {
  cartCompleteHandler();
  changeButtonText();
  personalisationCleanUp();
  synchronizeLinkedProductQuantitys();
  refreshMiniCart();
});

$(document).on('click','.mini-cart__product_btn a',function(e){
  const { id } = e.target;
  $('.accs-popup .products').each(function( index ) {
    const products = $(this).attr('data-products')
    if(products.indexOf(id.toString()) != -1){
        $(this).parents('.accs-popup').css("display","block")
    }
  })
  
//   $(`#product_${id}`).parents('.accs-popup').css("display","block")
  const swiper = document.querySelector('.carousel-3').swiper;
  swiper.update();
  const swiper2 = document.querySelector('.carousel-4').swiper;
  swiper2.update();
  const swiper3 = document.querySelector('.carousel-5').swiper;
  swiper3.update();
   
$('.accs-product__image .swiper-slide').eq(1).on('click',function(e){
    $(this).parents(".accs-product__card").addClass("acc-product__active")
});
  

})


$(document).on('click','.accs-close',function(e){
  $('.accs-popup').css("display","none");
  engravePopupCleanUp();

})
$('.js-fn__add-variant-to-basket').on('click',function(e){
  setTimeout(function(){
      //refreshMiniCart();
  }, 4000);

});


function refreshMiniCart(cart = CartJS.cart){
  var popup_class = '';
  let langCode = Weglot.getCurrentLang();
  $('.accessories-button').removeClass('active-office-desk-popup-open');
  $('.accessories-button').removeClass('active-desk-popup-open');
  cart.items.forEach(item=>{
    let itemHasEngraving = item.properties.Engraved?.length > 0 ?? false;
    const id  = item.id;
    const handle = item.handle;

    $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).css("display","none");
    $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).html('View Accessories');

    if ($(`.cart_area [data-item-key="${item.key}"] .product__property[data-prop="engraved"]`).length > 0) {
      let element = $(`.cart_area [data-item-key="${item.key}"] .product__property[data-prop="engraved"]`);
      element.html(element.html().replace('Engraved',window.translations.line_item.properties.engraved[langCode]))
    }
    if (handle.indexOf('personalisation') !== -1) {
      $(`.cart_area [data-item-key="${item.key}"] .mini-cart__product__name, [data-item-key="${item.key}"] .table_product_title a`).html(window.translations.line_item.title.personalisation[langCode])
    }



    let classes = ['active-desk-popup-open', 'active-office-desk-popup-open', 'personalisation-popup-open'];
    document.querySelectorAll(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).forEach((item)=>{
      classes.forEach((_class)=>{
        item.classList.remove(_class);
      })
    })
    var popup_class = '';
    if (handle.indexOf("aeris-active-office-desk") !== -1) {
      popup_class = 'active-office-desk-popup-open';
    }
    else if (handle.indexOf("aeris-active-desk") !== -1) {
      popup_class = 'active-desk-popup-open';
    }
    else if (handle.indexOf("aeris-swopper") !== -1 || handle.indexOf('personalisation') !== -1) {
      popup_class = 'personalisation-popup-open';
    }

    if(popup_class != ''){
          $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).addClass(""+popup_class+"");
          $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).css("display","inline-block");



          // $('.product_popup_'+id).addClass(""+popup_class+"");
          // $('.product_popup_'+id).css("display","inline-block");
        }

        if (handle.indexOf("aeris-swopper") !== -1) {
          // $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).html(translations.personalisation["add_engraving"][langCode])
          // $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).attr('data-has-engraving', ""+itemHasEngraving)
          // $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).css('display', itemHasEngraving? 'none':'inline-block')
          // personalisation popup removed from swopper
          $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).css('display', 'none')
        }
        if (handle.indexOf('personalisation') !== -1) {
          $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).html(translations.personalisation["edit_engraving"][langCode])
          $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).attr('data-has-engraving', ""+itemHasEngraving)
          $(`.cart_area .btn[data-item-key="${item.key}"], .mini-cart .btn[data-item-key="${item.key}"]`).css('display', itemHasEngraving? 'inline-block': 'none')
        }
  })
  $('.active-desk-popup-open').each(function (index) {
    if (window.AJAXCARTEVENTLISTENITEMS.indexOf(this) == -1) {
      window.AJAXCARTEVENTLISTENITEMS.push(this);
      $(this).on('click', (e)=>{openPopup(e)});
    }
  })
  $('.active-office-desk-popup-open').each(function (index) {
    if (window.AJAXCARTEVENTLISTENITEMS.indexOf(this) == -1) {
      window.AJAXCARTEVENTLISTENITEMS.push(this);
      $(this).on('click', (e)=>{openPopup(e)});
    }
  })
  $('.personalisation-popup-open').each(function (index) {
    if (window.AJAXCARTEVENTLISTENITEMS.indexOf(this) == -1) {
      window.AJAXCARTEVENTLISTENITEMS.push(this);
      $(this).on('click', (e)=>{openPopup(e)});
    }
  })
  function openPopup(e){
    let className = e.currentTarget.className;
    if (className.indexOf('active-desk-popup-open') !== -1) {
      $('.aeris-active-office-desk-popup').css("display","none");
      $('.aeris-active-desk-popup').css("display","block");
    }
    if (className.indexOf('active-office-desk-popup-open') !== -1) {
      $('.aeris-active-desk-popup').css("display","none");
      $('.aeris-active-office-desk-popup').css("display","block");
    }
    if (className.indexOf('personalisation-popup-open') !== -1) {
      let popupObj = {};
      if (e.currentTarget?.dataset?.itemKey) {
        popupObj = {itemKey:e.currentTarget?.dataset?.itemKey}
      } else if (currentProduct.selectedVariant) {
        let variant = currentProduct.selectedVariant;
        popupObj = {variant}
      }
      populatePopup(popupObj);
      $('.aeris-active-desk-popup').css("display","none");
      $('.aeris-active-office-desk-popup').css("display","none");
      $('.aeris-personalisation-popup').css("display","block");
      $('.aeris-personalisation-popup .personalisation__button').attr('data-item-key', e?.currentTarget?.dataset?.itemKey || "");
    }
  }

  function populatePopup({itemKey, variant}) {
    let langCode = Weglot.getCurrentLang();
    let item;
    if (itemKey) {
      let itemObj = getMainItemsWithLinkedItems(CartJS.cart).find((item)=>{
        let items = item.linkedItems.concat(item.mainItem);
        return items.some((x)=>{ return x.key == itemKey; });
      });
      item = itemObj?.mainItem || getItemFromKey(itemKey);
    }
    if (variant) {
      item = variant;
    }
      if (!item) { return };

      let engraving = item.properties?.Engraved;
      if (engraving) {
        document.querySelector('#custom-engraving').value = engraving;
        document.querySelector('#engraveAddToCart').innerText = translations.personalisation.update_engraving[langCode];
        document.querySelector('#engraveRemoveFromCart').style.display = "block";
      };
      let options = item.options_with_values? item.options_with_values :
      Object.entries(item).reduce((prev,cur)=>{
        if (cur[0].indexOf('option') !== -1) {
          prev.push({value:cur[1]});
        }
        return prev;
      }, []);

      let baseImageSelector = [{color:'weiß',selector:'white'},{color:'schwarz',selector:'black'},{color:'metallic',selector:'metalic'}].find((item)=>{return options[0]?.value.split('/')[0].indexOf(item.color) !== -1})?.selector
      + "_base" +
      (options[2]?.value?.toLowerCase().indexOf('rollen') !== -1? "_glider":"");

      if (!baseImageSelector.includes('undefined')) {
      document.querySelector('.personalisation-popup__image img').src = window.engravingProduct.images[baseImageSelector]+'&width=1500';
      document.querySelector('.personalisation-popup__image img').srcset = window.engravingProduct.images[baseImageSelector]+'&width=1200';
  }
  }

  $('.accs-product__image .swiper-slide').eq(1).on('click',function(e){
      $(this).parents(".accs-product__card").addClass("acc-product__active")
  });
}

function getItemFromKey(key) {
  return CartJS.cart.items.find((item)=>{ return item.key == key})
}

window.AJAXCARTEVENTLISTENITEMS = [];
$( document ).ready(function() {
  let waitForCartJS = function(){
    if(!window.CartJS){setTimeout(waitForCartJS); return; }
    const { items } = CartJS.getCart();
    CartJS.cart.items.forEach(item=>{
      const id  = item.id;
      const handle = item.handle;
    })
  }
  waitForCartJS();
});


window.addEventListener('addedToCartDatalayer',() => {
  let items = [];
  let totalPrice = 0;
  if (currentProduct.products) {
    items = currentProduct.products.map((currentProduct)=>{
      let _price = (currentProduct.price * 0.01) % 1 ? (currentProduct.price * 0.01) : (currentProduct.price * 0.01).toFixed(1);
      totalPrice += currentProduct.price * (currentProduct.changedQuantity && currentProduct.changedQuantity || 1);
      return {
        'item_id': '' + currentProduct.id ,
        'item_name': currentProduct.title?.replaceAll('"','')?.replaceAll("'",''),
        'item_brand': currentProduct.vendor?.replaceAll('"','')?.replaceAll("'",''),
        'item_variant': currentProduct.sku || currentProduct.handle,
        'price': parseFloat(_price),
        'quantity': (currentProduct.changedQuantity && currentProduct.changedQuantity || 1)
      }
    });
  } else {
    if (typeof currentProduct.selectedVariant.available != "undefined" && !currentProduct.selectedVariant.available) { return }

  let _price = (currentProduct.selectedVariant.price * 0.01) % 1 ? (currentProduct.selectedVariant.price * 0.01) : (currentProduct.selectedVariant.price * 0.01).toFixed(1);
    totalPrice += currentProduct.selectedVariant.price;
    items = [
      {
        'item_id': '' + currentProduct.id ,
        'item_name': currentProduct.title?.replaceAll('"','')?.replaceAll("'",''),
        'item_brand': currentProduct.vendor?.replaceAll('"','')?.replaceAll("'",''),
        'item_variant': currentProduct.selectedVariant.sku || currentProduct.handle,
        'price': parseFloat(_price),
        'quantity': 1
      }
    ]
  }
  totalPrice = (totalPrice * 0.01) % 1 ? (totalPrice * 0.01) : (totalPrice * 0.01).toFixed(1);
  dataLayer.push({ 'ecommerce': null });
  dataLayer.push({
    'event': 'add_to_cart',
    'ecommerce': {
      'currency': Shopify.currency.active,
      'value': parseFloat(totalPrice),
      'items': items
    }
  });
});
window.addEventListener('removeFromCartDatalayer',() => {
  let items = [];
  let totalPrice = 0;
  if (currentProduct.products && currentProduct.products.length > 0) {
    items = currentProduct.products.map((currentProduct)=>{
      let _price = (currentProduct.price * 0.01) % 1 ? (currentProduct.price * 0.01) : (currentProduct.price * 0.01).toFixed(1);
      totalPrice += currentProduct.price * (currentProduct.changedQuantity && currentProduct.changedQuantity || 1);
      return {
        'item_id': '' + currentProduct.id ,
        'item_name': currentProduct.title?.replaceAll('"','')?.replaceAll("'",''),
        'item_brand': currentProduct.vendor?.replaceAll('"','')?.replaceAll("'",''),
        'item_variant': currentProduct.sku || currentProduct.handle,
        'price': parseFloat(_price),
        'quantity': (currentProduct.changedQuantity || currentProduct.quantity || 1)
      }
    });
  } else {
    if (typeof currentProduct.selectedVariant.available != "undefined" && !currentProduct.selectedVariant.available) { return }

    let _price = (currentProduct.selectedVariant.price * 0.01) % 1 ? (currentProduct.selectedVariant.price * 0.01) : (currentProduct.selectedVariant.price * 0.01).toFixed(1);
    totalPrice += currentProduct.selectedVariant.price;
    items = [
        {
          'item_id': '' + currentProduct.id ,
          'item_name': currentProduct.title?.replaceAll('"','')?.replaceAll("'",''),
          'item_brand': currentProduct.vendor?.replaceAll('"','')?.replaceAll("'",''),
          'item_variant': currentProduct.selectedVariant.sku || currentProduct.handle,
          'price': parseFloat(_price),
        'quantity': currentProduct.quantity || 1
        }
      ]
  }
  totalPrice = (totalPrice * 0.01) % 1 ? (totalPrice * 0.01) : (totalPrice * 0.01).toFixed(1);
  dataLayer.push({ 'ecommerce': null });
  dataLayer.push({
    'event': 'remove_from_cart',
    'ecommerce': {
      'currency': Shopify.currency.active,
      'value': parseFloat(totalPrice),
      'items': items
    }
  });
});
window.currentProduct = window.currentProduct || {};
window.miniCart = {
  addToCart: function (changedItems) {
    if (changedItems.length > 0) {
      window.currentProduct.products = changedItems;
      let event = new Event('addedToCartDatalayer');
      window.dispatchEvent(event);
      }
  },
  removeFromCart: function (changedItems) {
    if (changedItems.length > 0) {
      window.currentProduct.products = changedItems;
      let event = new Event('removeFromCartDatalayer');
      window.dispatchEvent(event);
    }
  }
}
